import { CardType } from "./DigitalCard";

export const cardTypes: {
    id: CardType;
    label: string;
    color: string;
    benefits: string[];
}[] = [
        {
            id: 'Green',
            label: 'Green Card',
            color: 'green',
            benefits: ['Basic rewards', '1% cashback', 'No annual fee']
        },
        {
            id: 'Silver',
            label: 'Silver Card',
            color: 'linear-gradient(45deg, #c0c0c0 0%, #dcdcdc 100%)',
            benefits: ['Enhanced rewards', '2% cashback', 'Travel insurance']
        },
        {
            id: 'Gold',
            label: 'Gold Card',
            color: 'linear-gradient(45deg, #facc15 0%, #eab308 100%)',
            benefits: ['Premium rewards', '3% cashback', 'Airport lounge access', 'Priority support']
        }
    ];